import { confirm } from 'components/modals/confirm'
import { isObjectDeepEmpty } from 'util/object'
import { DirtyFieldsVacinacaoModal } from 'view/atendimentos/atendimento-vacinacao/fields-summary-modal/DirtyFieldsVacinacaoModal'
import { AtendimentoVacinacaoState } from 'view/atendimentos/atendimento-vacinacao/model'
import { VacinacaoDirtyFieldsModel } from 'view/atendimentos/detail/vacinacao/model-vacinacao'
import { getDirtyFieldsVacinacao } from 'view/atendimentos/detail/vacinacao/util-vacinacao'
import {
  RetificacaoConfirmModalOptions,
  RetificarMutations,
} from 'view/retificacao-atendimento/model-retificacaoAtendimento'
import {
  modalSegundaVerificacao,
  modalSemAlteracoes,
} from 'view/retificacao-atendimento/retificacaoAtendimentoConfirmModal'

export interface RetificacaoVacinacaoConfirmModalOptions
  extends RetificacaoConfirmModalOptions<AtendimentoVacinacaoState, RetificarMutations> {
  canHaveCondicaoMaternal: boolean
}

export function retificacaoVacinacaoConfirmModal(options: Readonly<RetificacaoVacinacaoConfirmModalOptions>) {
  const { onRetificarSemAlteracoes, initialValues, currentValues, ...rest } = options

  const dirtyFields = getDirtyFieldsVacinacao(initialValues, currentValues)

  return isObjectDeepEmpty(dirtyFields)
    ? modalSemAlteracoes({ onRetificarSemAlteracoes })
    : modalComAlteracoesRetificacaoVacinacao(rest, dirtyFields)
}

export async function modalComAlteracoesRetificacaoVacinacao(
  options: Omit<
    RetificacaoVacinacaoConfirmModalOptions,
    'onRetificarSemAlteracoes' | 'initialValues' | 'currentValues'
  >,
  dirtyFields: VacinacaoDirtyFieldsModel
) {
  const { canHaveCondicaoMaternal, ...rest } = options

  const confirmed = await confirm({
    title: 'Os seguintes registros serão retificados:',
    icon: {
      name: 'exclamationTriangleOutline',
      fill: 'alert',
    },
    size: 'small',
    render: () => (
      <DirtyFieldsVacinacaoModal dirtyFields={dirtyFields} canHaveCondicaoMaternal={canHaveCondicaoMaternal} />
    ),
  })()

  if (confirmed) {
    return modalSegundaVerificacao(rest)
  }
}
